import { render, staticRenderFns } from "./SingleTransaction.vue?vue&type=template&id=71a68fc4&scoped=true&"
import script from "./SingleTransaction.vue?vue&type=script&lang=js&"
export * from "./SingleTransaction.vue?vue&type=script&lang=js&"
import style0 from "./SingleTransaction.vue?vue&type=style&index=0&id=71a68fc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a68fc4",
  null
  
)

export default component.exports